/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DirectoryPersonGroup = {
  /**
   * Directory group ID.
   */
  id: string;
  /**
   * Directory group name.
   */
  name: string;
};

/** @internal */
export const DirectoryPersonGroup$inboundSchema: z.ZodMiniType<
  DirectoryPersonGroup,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
});

export function directoryPersonGroupFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryPersonGroup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryPersonGroup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryPersonGroup' from JSON`,
  );
}
